export default {
  setGenericCollection(state, { params, data }) {
    if (!state || !params || !state[params.type] || !data) return;
    
    if (Array.isArray(data.results)) {
      state[params.type] = data.results;

      if(params.only === undefined) {
        state[`${params.type}Count`] = data.count;  
      }
      
    } else {
      console.error("Expected array data for collection:", params.type);
    }
  },
  

addToGenericCollection(state, { collection, data }) {
  if (!state || !collection || !state[collection] || !data) return;

  const itemsToAdd = Array.isArray(data) ? data : [data];

  if (Array.isArray(state[collection])) {
    itemsToAdd.forEach(item => {
      if (!state[collection].some(existingItem => existingItem.id === item.id)) {
        state[collection].push(item);  
      }
    });
  } else {
    console.error("Collection is not an array:", collection);
  }
},

updateInGenericCollection(state, { collection, data }) {
  if (!state || !collection || !state[collection] || !data) return;

  const itemsToUpdate = Array.isArray(data) ? data : [data];

  if (Array.isArray(state[collection])) {
    itemsToUpdate.forEach(item => {
      const index = state[collection].findIndex(existingItem => existingItem.id === item.id);
      if (index !== -1) {       
        state[collection].splice(index, 1, { ...state[collection][index], ...item });
      } else {        
        state[collection].push(item);
      }
    });
  } else {
    console.error("Collection is not an array:", collection);
  }
},

  removeFromGenericCollection(state, { collection, data }) {
    if (!state || !collection || !state[collection] || !data) return;
    if (Array.isArray(state[collection])) {
      state[collection] = state[collection].filter((el) => el.id !== data?.id);
    } else {
      console.error("Collection is not an array:", collection);
    }
  },
};
